var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.23047C8.5 3.98783 9.50736 2.98047 10.75 2.98047H13.25C14.4926 2.98047 15.5 3.98783 15.5 5.23047V7.00047H18.75C19.9926 7.00047 21 8.00782 21 9.25047V20.2505C21 20.6647 20.6642 21.0005 20.25 21.0005H3.75C3.33579 21.0005 3 20.6647 3 20.2505V12.2505C3 11.0078 4.00736 10.0005 5.25 10.0005H8.5V5.23047ZM10 19.5005H14V5.23047C14 4.81626 13.6642 4.48047 13.25 4.48047H10.75C10.3358 4.48047 10 4.81625 10 5.23047V19.5005ZM8.5 11.5005H5.25C4.83579 11.5005 4.5 11.8363 4.5 12.2505V19.5005H8.5V11.5005ZM15.5 19.5005V8.50047H18.75C19.1642 8.50047 19.5 8.83625 19.5 9.25047V19.5005H15.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.e1272f0f1c59f28a6f697506f4ffed02.svg";
export { ForwardRef as ReactComponent };